"use strict";
// @ts-nocheck
// prettier-ignore
/* eslint-disable */
// @segment/tsub 2.0.0 - GENERATED DO NOT MODIFY
/*! For license information please see tsub.js.LICENSE.txt */
!function (t, r) { if ("object" == typeof exports && "object" == typeof module)
    module.exports = r();
else if ("function" == typeof define && define.amd)
    define([], r);
else {
    var e = r();
    for (var n in e)
        ("object" == typeof exports ? exports : t)[n] = e[n];
} }(self, (function () { return (function () { var t = { 2870: function (t, r, e) {
        "use strict";
        var n = this && this.__importDefault || function (t) { return t && t.__esModule ? t : { default: t }; };
        Object.defineProperty(r, "__esModule", { value: !0 }), r.Store = r.matches = r.transform = void 0;
        var o = e(4303);
        Object.defineProperty(r, "transform", { enumerable: !0, get: function () { return n(o).default; } });
        var s = e(2370);
        Object.defineProperty(r, "matches", { enumerable: !0, get: function () { return n(s).default; } });
        var i = e(1444);
        Object.defineProperty(r, "Store", { enumerable: !0, get: function () { return n(i).default; } });
    }, 2370: function (t, r, e) {
        "use strict";
        var n = this && this.__importDefault || function (t) { return t && t.__esModule ? t : { default: t }; };
        Object.defineProperty(r, "__esModule", { value: !0 });
        var o = n(e(7843));
        function s(t, r) { if (!Array.isArray(t))
            return !0 === i(t, r); var e, n, o, f, p = t[0]; switch (p) {
            case "!": return !s(t[1], r);
            case "or":
                for (var l = 1; l < t.length; l++)
                    if (s(t[l], r))
                        return !0;
                return !1;
            case "and":
                for (l = 1; l < t.length; l++)
                    if (!s(t[l], r))
                        return !1;
                return !0;
            case "=":
            case "!=": return function (t, r, e, n) { switch (u(t) && (t = s(t, n)), u(r) && (r = s(r, n)), "object" == typeof t && "object" == typeof r && (t = JSON.stringify(t), r = JSON.stringify(r)), e) {
                case "=": return t === r;
                case "!=": return t !== r;
                default: throw new Error("Invalid operator in compareItems: ".concat(e));
            } }(i(t[1], r), i(t[2], r), p, r);
            case "<=":
            case "<":
            case ">":
            case ">=": return function (t, r, e, n) { if (u(t) && (t = s(t, n)), u(r) && (r = s(r, n)), "number" != typeof t || "number" != typeof r)
                return !1; switch (e) {
                case "<=": return t <= r;
                case ">=": return t >= r;
                case "<": return t < r;
                case ">": return t > r;
                default: throw new Error("Invalid operator in compareNumbers: ".concat(e));
            } }(i(t[1], r), i(t[2], r), p, r);
            case "in": return function (t, r, e) { return void 0 !== r.find((function (r) { return i(r, e) === t; })); }(i(t[1], r), i(t[2], r), r);
            case "contains": return o = i(t[1], r), f = i(t[2], r), "string" == typeof o && "string" == typeof f && -1 !== o.indexOf(f);
            case "match": return e = i(t[1], r), n = i(t[2], r), "string" == typeof e && "string" == typeof n && function (t, r) { var e, n; t: for (; t.length > 0;) {
                var o, s;
                if (o = (e = a(t)).star, s = e.chunk, t = e.pattern, o && "" === s)
                    return !0;
                var i = c(s, r), u = i.t, f = i.ok, p = i.err;
                if (p)
                    return !1;
                if (!f || !(0 === u.length || t.length > 0)) {
                    if (o)
                        for (var l = 0; l < r.length; l++) {
                            if (u = (n = c(s, r.slice(l + 1))).t, f = n.ok, p = n.err, f) {
                                if (0 === t.length && u.length > 0)
                                    continue;
                                r = u;
                                continue t;
                            }
                            if (p)
                                return !1;
                        }
                    return !1;
                }
                r = u;
            } return 0 === r.length; }(n, e);
            case "lowercase":
                var v = i(t[1], r);
                return "string" != typeof v ? null : v.toLowerCase();
            case "typeof": return typeof i(t[1], r);
            case "length": return function (t) { return null === t ? 0 : Array.isArray(t) || "string" == typeof t ? t.length : NaN; }(i(t[1], r));
            default: throw new Error("FQL IR could not evaluate for token: ".concat(p));
        } }
        function i(t, r) { return Array.isArray(t) ? t : "object" == typeof t ? t.value : (0, o.default)(r, t); }
        function u(t) { return !!Array.isArray(t) && (("lowercase" === t[0] || "length" === t[0] || "typeof" === t[0]) && 2 === t.length || ("contains" === t[0] || "match" === t[0]) && 3 === t.length); }
        function a(t) { for (var r = { star: !1, chunk: "", pattern: "" }; t.length > 0 && "*" === t[0];)
            t = t.slice(1), r.star = !0; var e, n = !1; t: for (e = 0; e < t.length; e++)
            switch (t[e]) {
                case "\\":
                    e + 1 < t.length && e++;
                    break;
                case "[":
                    n = !0;
                    break;
                case "]":
                    n = !1;
                    break;
                case "*": if (!n)
                    break t;
            } return r.chunk = t.slice(0, e), r.pattern = t.slice(e), r; }
        function c(t, r) { for (var e, n, o = { t: "", ok: !1, err: !1 }; t.length > 0;) {
            if (0 === r.length)
                return o;
            switch (t[0]) {
                case "[":
                    var s = r[0];
                    r = r.slice(1);
                    var i = !0;
                    (t = t.slice(1)).length > 0 && "^" === t[0] && (i = !1, t = t.slice(1));
                    for (var u = !1, a = 0;;) {
                        if (t.length > 0 && "]" === t[0] && a > 0) {
                            t = t.slice(1);
                            break;
                        }
                        var c, p = "";
                        if (c = (e = f(t)).char, t = e.newChunk, e.err)
                            return o;
                        if (p = c, "-" === t[0] && (p = (n = f(t.slice(1))).char, t = n.newChunk, n.err))
                            return o;
                        c <= s && s <= p && (u = !0), a++;
                    }
                    if (u !== i)
                        return o;
                    break;
                case "?":
                    r = r.slice(1), t = t.slice(1);
                    break;
                case "\\": if (0 === (t = t.slice(1)).length)
                    return o.err = !0, o;
                default:
                    if (t[0] !== r[0])
                        return o;
                    r = r.slice(1), t = t.slice(1);
            }
        } return o.t = r, o.ok = !0, o.err = !1, o; }
        function f(t) { var r = { char: "", newChunk: "", err: !1 }; return 0 === t.length || "-" === t[0] || "]" === t[0] || "\\" === t[0] && 0 === (t = t.slice(1)).length ? (r.err = !0, r) : (r.char = t[0], r.newChunk = t.slice(1), 0 === r.newChunk.length && (r.err = !0), r); }
        r.default = function (t, r) { if (!r)
            throw new Error("No matcher supplied!"); switch (r.type) {
            case "all": return !0;
            case "fql": return function (t, r) { if (!t)
                return !1; try {
                t = JSON.parse(t);
            }
            catch (r) {
                throw new Error('Failed to JSON.parse FQL intermediate representation "'.concat(t, '": ').concat(r));
            } var e = s(t, r); return "boolean" == typeof e && e; }(r.ir, t);
            default: throw new Error("Matcher of type ".concat(r.type, " unsupported."));
        } };
    }, 1444: function (t, r) {
        "use strict";
        Object.defineProperty(r, "__esModule", { value: !0 });
        var e = function () { function t(t) { this.rules = [], this.rules = t || []; } return t.prototype.getRulesByDestinationName = function (t) { for (var r = [], e = 0, n = this.rules; e < n.length; e++) {
            var o = n[e];
            o.destinationName !== t && void 0 !== o.destinationName || r.push(o);
        } return r; }, t; }();
        r.default = e;
    }, 4303: function (t, r, e) {
        "use strict";
        var n = this && this.__importDefault || function (t) { return t && t.__esModule ? t : { default: t }; };
        Object.defineProperty(r, "__esModule", { value: !0 });
        var o = n(e(374)), s = n(e(7843)), i = n(e(5500)), u = e(9014), a = e(4966);
        function c(t, r) { p(t, r.drop, (function (t, r) { r.forEach((function (r) { return delete t[r]; })); })); }
        function f(t, r) { p(t, r.allow, (function (t, r) { Object.keys(t).forEach((function (e) { r.includes(e) || delete t[e]; })); })); }
        function p(t, r, e) { Object.entries(r).forEach((function (r) { var n = r[0], o = r[1], i = function (t) { "object" == typeof t && null !== t && e(t, o); }, u = "" === n ? t : (0, s.default)(t, n); Array.isArray(u) ? u.forEach(i) : i(u); })); }
        function l(t, r) { var e = JSON.parse(JSON.stringify(t)); for (var n in r.map)
            if (r.map.hasOwnProperty(n)) {
                var o = r.map[n], i = n.split("."), c = void 0;
                if (i.length > 1 ? (i.pop(), c = (0, s.default)(e, i.join("."))) : c = t, "object" == typeof c) {
                    if (o.copy) {
                        var f = (0, s.default)(e, o.copy);
                        void 0 !== f && (0, u.dset)(t, n, f);
                    }
                    else if (o.move) {
                        var p = (0, s.default)(e, o.move);
                        void 0 !== p && (0, u.dset)(t, n, p), (0, a.unset)(t, o.move);
                    }
                    else
                        o.hasOwnProperty("set") && (0, u.dset)(t, n, o.set);
                    if (o.to_string) {
                        var l = (0, s.default)(t, n);
                        if ("string" == typeof l || "object" == typeof l && null !== l)
                            continue;
                        void 0 !== l ? (0, u.dset)(t, n, JSON.stringify(l)) : (0, u.dset)(t, n, "undefined");
                    }
                }
            } }
        function v(t, r) { return !(r.sample.percent <= 0) && (r.sample.percent >= 1 || (r.sample.path ? function (t, r) { var e = (0, s.default)(t, r.sample.path), n = (0, o.default)(JSON.stringify(e)), u = -64, a = []; y(n.slice(0, 8), a); for (var c = 0, f = 0; f < 64 && 1 !== a[f]; f++)
            c++; if (0 !== c) {
            var p = [];
            y(n.slice(9, 16), p), u -= c, a.splice(0, c), p.splice(64 - c), a = a.concat(p);
        } return a[63] = 0 === a[63] ? 1 : 0, (0, i.default)(parseInt(a.join(""), 2), u) < r.sample.percent; }(t, r) : (e = r.sample.percent, Math.random() <= e))); var e; }
        function y(t, r) { for (var e = 0; e < 8; e++)
            for (var n = t[e], o = 128; o >= 1; o /= 2)
                n - o >= 0 ? (n -= o, r.push(1)) : r.push(0); }
        r.default = function (t, r) { for (var e = t, n = 0, o = r; n < o.length; n++) {
            var s = o[n];
            switch (s.type) {
                case "drop": return null;
                case "drop_properties":
                    c(e, s.config);
                    break;
                case "allow_properties":
                    f(e, s.config);
                    break;
                case "sample_event":
                    if (v(e, s.config))
                        break;
                    return null;
                case "map_properties":
                    l(e, s.config);
                    break;
                case "hash_properties": break;
                default: throw new Error('Transformer of type "'.concat(s.type, '" is unsupported.'));
            }
        } return e; };
    }, 4966: function (t, r, e) {
        "use strict";
        var n = this && this.__importDefault || function (t) { return t && t.__esModule ? t : { default: t }; };
        Object.defineProperty(r, "__esModule", { value: !0 }), r.unset = void 0;
        var o = n(e(7843));
        r.unset = function (t, r) { if ((0, o.default)(t, r)) {
            for (var e = r.split("."), n = e.pop(); e.length && "\\" === e[e.length - 1].slice(-1);)
                n = e.pop().slice(0, -1) + "." + n;
            for (; e.length;)
                t = t[r = e.shift()];
            return delete t[n];
        } return !0; };
    }, 9014: function (t, r) { r.dset = function (t, r, e) { r.split && (r = r.split(".")); for (var n, o, s = 0, i = r.length, u = t; s < i && "__proto__" !== (o = r[s++]) && "constructor" !== o && "prototype" !== o;)
        u = u[o] = s === i ? e : typeof (n = u[o]) == typeof r ? n : 0 * r[s] != 0 || ~("" + r[s]).indexOf(".") ? {} : []; }; }, 3304: function (t) {
        "use strict";
        var r = "function" == typeof Float64Array ? Float64Array : void 0;
        t.exports = r;
    }, 7382: function (t, r, e) {
        "use strict";
        var n, o = e(5569), s = e(3304), i = e(8482);
        n = o() ? s : i, t.exports = n;
    }, 8482: function (t) {
        "use strict";
        t.exports = function () { throw new Error("not implemented"); };
    }, 6322: function (t, r, e) {
        "use strict";
        var n, o = e(2508), s = e(5679), i = e(882);
        n = o() ? s : i, t.exports = n;
    }, 882: function (t) {
        "use strict";
        t.exports = function () { throw new Error("not implemented"); };
    }, 5679: function (t) {
        "use strict";
        var r = "function" == typeof Uint16Array ? Uint16Array : void 0;
        t.exports = r;
    }, 4773: function (t, r, e) {
        "use strict";
        var n, o = e(9773), s = e(3004), i = e(3078);
        n = o() ? s : i, t.exports = n;
    }, 3078: function (t) {
        "use strict";
        t.exports = function () { throw new Error("not implemented"); };
    }, 3004: function (t) {
        "use strict";
        var r = "function" == typeof Uint32Array ? Uint32Array : void 0;
        t.exports = r;
    }, 7980: function (t, r, e) {
        "use strict";
        var n, o = e(8114), s = e(6737), i = e(3357);
        n = o() ? s : i, t.exports = n;
    }, 3357: function (t) {
        "use strict";
        t.exports = function () { throw new Error("not implemented"); };
    }, 6737: function (t) {
        "use strict";
        var r = "function" == typeof Uint8Array ? Uint8Array : void 0;
        t.exports = r;
    }, 2684: function (t) {
        "use strict";
        var r = "function" == typeof Float64Array ? Float64Array : null;
        t.exports = r;
    }, 5569: function (t, r, e) {
        "use strict";
        var n = e(3876);
        t.exports = n;
    }, 3876: function (t, r, e) {
        "use strict";
        var n = e(1448), o = e(2684);
        t.exports = function () { var t, r; if ("function" != typeof o)
            return !1; try {
            r = new o([1, 3.14, -3.14, NaN]), t = n(r) && 1 === r[0] && 3.14 === r[1] && -3.14 === r[2] && r[3] != r[3];
        }
        catch (r) {
            t = !1;
        } return t; };
    }, 9048: function (t, r, e) {
        "use strict";
        var n = e(3763);
        t.exports = n;
    }, 3763: function (t) {
        "use strict";
        var r = Object.prototype.hasOwnProperty;
        t.exports = function (t, e) { return null != t && r.call(t, e); };
    }, 7009: function (t, r, e) {
        "use strict";
        var n = e(6784);
        t.exports = n;
    }, 6784: function (t) {
        "use strict";
        t.exports = function () { return "function" == typeof Symbol && "symbol" == typeof Symbol("foo"); };
    }, 3123: function (t, r, e) {
        "use strict";
        var n = e(8481);
        t.exports = n;
    }, 8481: function (t, r, e) {
        "use strict";
        var n = e(7009)();
        t.exports = function () { return n && "symbol" == typeof Symbol.toStringTag; };
    }, 2508: function (t, r, e) {
        "use strict";
        var n = e(3403);
        t.exports = n;
    }, 3403: function (t, r, e) {
        "use strict";
        var n = e(768), o = e(9668), s = e(187);
        t.exports = function () { var t, r; if ("function" != typeof s)
            return !1; try {
            r = new s(r = [1, 3.14, -3.14, o + 1, o + 2]), t = n(r) && 1 === r[0] && 3 === r[1] && r[2] === o - 2 && 0 === r[3] && 1 === r[4];
        }
        catch (r) {
            t = !1;
        } return t; };
    }, 187: function (t) {
        "use strict";
        var r = "function" == typeof Uint16Array ? Uint16Array : null;
        t.exports = r;
    }, 9773: function (t, r, e) {
        "use strict";
        var n = e(2822);
        t.exports = n;
    }, 2822: function (t, r, e) {
        "use strict";
        var n = e(2744), o = e(3899), s = e(746);
        t.exports = function () { var t, r; if ("function" != typeof s)
            return !1; try {
            r = new s(r = [1, 3.14, -3.14, o + 1, o + 2]), t = n(r) && 1 === r[0] && 3 === r[1] && r[2] === o - 2 && 0 === r[3] && 1 === r[4];
        }
        catch (r) {
            t = !1;
        } return t; };
    }, 746: function (t) {
        "use strict";
        var r = "function" == typeof Uint32Array ? Uint32Array : null;
        t.exports = r;
    }, 8114: function (t, r, e) {
        "use strict";
        var n = e(8066);
        t.exports = n;
    }, 8066: function (t, r, e) {
        "use strict";
        var n = e(8279), o = e(3443), s = e(2731);
        t.exports = function () { var t, r; if ("function" != typeof s)
            return !1; try {
            r = new s(r = [1, 3.14, -3.14, o + 1, o + 2]), t = n(r) && 1 === r[0] && 3 === r[1] && r[2] === o - 2 && 0 === r[3] && 1 === r[4];
        }
        catch (r) {
            t = !1;
        } return t; };
    }, 2731: function (t) {
        "use strict";
        var r = "function" == typeof Uint8Array ? Uint8Array : null;
        t.exports = r;
    }, 1448: function (t, r, e) {
        "use strict";
        var n = e(1453);
        t.exports = n;
    }, 1453: function (t, r, e) {
        "use strict";
        var n = e(6208), o = "function" == typeof Float64Array;
        t.exports = function (t) { return o && t instanceof Float64Array || "[object Float64Array]" === n(t); };
    }, 9331: function (t, r, e) {
        "use strict";
        var n = e(7980), o = { uint16: e(6322), uint8: n };
        t.exports = o;
    }, 5902: function (t, r, e) {
        "use strict";
        var n = e(4106);
        t.exports = n;
    }, 4106: function (t, r, e) {
        "use strict";
        var n, o, s = e(9331);
        (o = new s.uint16(1))[0] = 4660, n = 52 === new s.uint8(o.buffer)[0], t.exports = n;
    }, 768: function (t, r, e) {
        "use strict";
        var n = e(3823);
        t.exports = n;
    }, 3823: function (t, r, e) {
        "use strict";
        var n = e(6208), o = "function" == typeof Uint16Array;
        t.exports = function (t) { return o && t instanceof Uint16Array || "[object Uint16Array]" === n(t); };
    }, 2744: function (t, r, e) {
        "use strict";
        var n = e(2326);
        t.exports = n;
    }, 2326: function (t, r, e) {
        "use strict";
        var n = e(6208), o = "function" == typeof Uint32Array;
        t.exports = function (t) { return o && t instanceof Uint32Array || "[object Uint32Array]" === n(t); };
    }, 8279: function (t, r, e) {
        "use strict";
        var n = e(208);
        t.exports = n;
    }, 208: function (t, r, e) {
        "use strict";
        var n = e(6208), o = "function" == typeof Uint8Array;
        t.exports = function (t) { return o && t instanceof Uint8Array || "[object Uint8Array]" === n(t); };
    }, 6315: function (t) {
        "use strict";
        t.exports = 1023;
    }, 1686: function (t) {
        "use strict";
        t.exports = 2147483647;
    }, 3105: function (t) {
        "use strict";
        t.exports = 2146435072;
    }, 3449: function (t) {
        "use strict";
        t.exports = 2147483648;
    }, 6988: function (t) {
        "use strict";
        t.exports = -1023;
    }, 9777: function (t) {
        "use strict";
        t.exports = 1023;
    }, 3690: function (t) {
        "use strict";
        t.exports = -1074;
    }, 2918: function (t, r, e) {
        "use strict";
        var n = e(4772).NEGATIVE_INFINITY;
        t.exports = n;
    }, 4165: function (t) {
        "use strict";
        var r = Number.POSITIVE_INFINITY;
        t.exports = r;
    }, 6488: function (t) {
        "use strict";
        t.exports = 22250738585072014e-324;
    }, 9668: function (t) {
        "use strict";
        t.exports = 65535;
    }, 3899: function (t) {
        "use strict";
        t.exports = 4294967295;
    }, 3443: function (t) {
        "use strict";
        t.exports = 255;
    }, 7011: function (t, r, e) {
        "use strict";
        var n = e(812);
        t.exports = n;
    }, 812: function (t, r, e) {
        "use strict";
        var n = e(4165), o = e(2918);
        t.exports = function (t) { return t === n || t === o; };
    }, 1883: function (t, r, e) {
        "use strict";
        var n = e(1797);
        t.exports = n;
    }, 1797: function (t) {
        "use strict";
        t.exports = function (t) { return t != t; };
    }, 513: function (t, r, e) {
        "use strict";
        var n = e(5760);
        t.exports = n;
    }, 5760: function (t) {
        "use strict";
        t.exports = function (t) { return Math.abs(t); };
    }, 5848: function (t, r, e) {
        "use strict";
        var n = e(677);
        t.exports = n;
    }, 677: function (t, r, e) {
        "use strict";
        var n = e(3449), o = e(1686), s = e(7838), i = e(1921), u = e(2490), a = [0, 0];
        t.exports = function (t, r) { var e, c; return s.assign(t, a, 1, 0), e = a[0], e &= o, c = i(r), u(e |= c &= n, a[1]); };
    }, 5500: function (t, r, e) {
        "use strict";
        var n = e(8397);
        t.exports = n;
    }, 8397: function (t, r, e) {
        "use strict";
        var n = e(4165), o = e(2918), s = e(6315), i = e(9777), u = e(6988), a = e(3690), c = e(1883), f = e(7011), p = e(5848), l = e(4948), v = e(8478), y = e(7838), d = e(2490), h = [0, 0], x = [0, 0];
        t.exports = function (t, r) { var e, b; return 0 === t || c(t) || f(t) ? t : (l(h, t), r += h[1], (r += v(t = h[0])) < a ? p(0, t) : r > i ? t < 0 ? o : n : (r <= u ? (r += 52, b = 2220446049250313e-31) : b = 1, y(x, t), e = x[0], e &= 2148532223, b * d(e |= r + s << 20, x[1]))); };
    }, 4772: function (t, r, e) {
        "use strict";
        var n = e(7548);
        t.exports = n;
    }, 7548: function (t) {
        "use strict";
        t.exports = Number;
    }, 8478: function (t, r, e) {
        "use strict";
        var n = e(4500);
        t.exports = n;
    }, 4500: function (t, r, e) {
        "use strict";
        var n = e(1921), o = e(3105), s = e(6315);
        t.exports = function (t) { var r = n(t); return (r = (r & o) >>> 20) - s | 0; };
    }, 2490: function (t, r, e) {
        "use strict";
        var n = e(9639);
        t.exports = n;
    }, 4445: function (t, r, e) {
        "use strict";
        var n, o, s;
        !0 === e(5902) ? (o = 1, s = 0) : (o = 0, s = 1), n = { HIGH: o, LOW: s }, t.exports = n;
    }, 9639: function (t, r, e) {
        "use strict";
        var n = e(4773), o = e(7382), s = e(4445), i = new o(1), u = new n(i.buffer), a = s.HIGH, c = s.LOW;
        t.exports = function (t, r) { return u[a] = t, u[c] = r, i[0]; };
    }, 5646: function (t, r, e) {
        "use strict";
        var n;
        n = !0 === e(5902) ? 1 : 0, t.exports = n;
    }, 1921: function (t, r, e) {
        "use strict";
        var n = e(6285);
        t.exports = n;
    }, 6285: function (t, r, e) {
        "use strict";
        var n = e(4773), o = e(7382), s = e(5646), i = new o(1), u = new n(i.buffer);
        t.exports = function (t) { return i[0] = t, u[s]; };
    }, 9024: function (t, r, e) {
        "use strict";
        var n = e(6488), o = e(7011), s = e(1883), i = e(513);
        t.exports = function (t, r, e, u) { return s(t) || o(t) ? (r[u] = t, r[u + e] = 0, r) : 0 !== t && i(t) < n ? (r[u] = 4503599627370496 * t, r[u + e] = -52, r) : (r[u] = t, r[u + e] = 0, r); };
    }, 4948: function (t, r, e) {
        "use strict";
        var n = e(7576), o = e(9422);
        n(o, "assign", e(9024)), t.exports = o;
    }, 9422: function (t, r, e) {
        "use strict";
        var n = e(9024);
        t.exports = function (t) { return n(t, [0, 0], 1, 0); };
    }, 5239: function (t, r, e) {
        "use strict";
        var n = e(4773), o = e(7382), s = e(5782), i = new o(1), u = new n(i.buffer), a = s.HIGH, c = s.LOW;
        t.exports = function (t, r, e, n) { return i[0] = t, r[n] = u[a], r[n + e] = u[c], r; };
    }, 7838: function (t, r, e) {
        "use strict";
        var n = e(7576), o = e(4010);
        n(o, "assign", e(5239)), t.exports = o;
    }, 5782: function (t, r, e) {
        "use strict";
        var n, o, s;
        !0 === e(5902) ? (o = 1, s = 0) : (o = 0, s = 1), n = { HIGH: o, LOW: s }, t.exports = n;
    }, 4010: function (t, r, e) {
        "use strict";
        var n = e(5239);
        t.exports = function (t) { return n(t, [0, 0], 1, 0); };
    }, 7576: function (t, r, e) {
        "use strict";
        var n = e(7063);
        t.exports = n;
    }, 7063: function (t, r, e) {
        "use strict";
        var n = e(6691);
        t.exports = function (t, r, e) { n(t, r, { configurable: !1, enumerable: !1, writable: !1, value: e }); };
    }, 2073: function (t) {
        "use strict";
        var r = Object.defineProperty;
        t.exports = r;
    }, 1680: function (t) {
        "use strict";
        var r = "function" == typeof Object.defineProperty ? Object.defineProperty : null;
        t.exports = r;
    }, 1471: function (t, r, e) {
        "use strict";
        var n = e(1680);
        t.exports = function () { try {
            return n({}, "x", {}), !0;
        }
        catch (t) {
            return !1;
        } };
    }, 6691: function (t, r, e) {
        "use strict";
        var n, o = e(1471), s = e(2073), i = e(1309);
        n = o() ? s : i, t.exports = n;
    }, 1309: function (t) {
        "use strict";
        var r = Object.prototype, e = r.toString, n = r.__defineGetter__, o = r.__defineSetter__, s = r.__lookupGetter__, i = r.__lookupSetter__;
        t.exports = function (t, u, a) { var c, f, p, l; if ("object" != typeof t || null === t || "[object Array]" === e.call(t))
            throw new TypeError("invalid argument. First argument must be an object. Value: `" + t + "`."); if ("object" != typeof a || null === a || "[object Array]" === e.call(a))
            throw new TypeError("invalid argument. Property descriptor must be an object. Value: `" + a + "`."); if ((f = "value" in a) && (s.call(t, u) || i.call(t, u) ? (c = t.__proto__, t.__proto__ = r, delete t[u], t[u] = a.value, t.__proto__ = c) : t[u] = a.value), p = "get" in a, l = "set" in a, f && (p || l))
            throw new Error("invalid argument. Cannot specify one or more accessors and a value or writable attribute in the property descriptor."); return p && n && n.call(t, u, a.get), l && o && o.call(t, u, a.set), t; };
    }, 6208: function (t, r, e) {
        "use strict";
        var n, o = e(3123), s = e(7407), i = e(4210);
        n = o() ? i : s, t.exports = n;
    }, 7407: function (t, r, e) {
        "use strict";
        var n = e(173);
        t.exports = function (t) { return n.call(t); };
    }, 4210: function (t, r, e) {
        "use strict";
        var n = e(9048), o = e(1403), s = e(173);
        t.exports = function (t) { var r, e, i; if (null == t)
            return s.call(t); e = t[o], r = n(t, o); try {
            t[o] = void 0;
        }
        catch (r) {
            return s.call(t);
        } return i = s.call(t), r ? t[o] = e : delete t[o], i; };
    }, 173: function (t) {
        "use strict";
        var r = Object.prototype.toString;
        t.exports = r;
    }, 1403: function (t) {
        "use strict";
        var r = "function" == typeof Symbol ? Symbol.toStringTag : "";
        t.exports = r;
    }, 7843: function (t) { t.exports = function (t, r, e, n, o) { for (r = r.split ? r.split(".") : r, n = 0; n < r.length; n++)
        t = t ? t[r[n]] : o; return t === o ? e : t; }; }, 374: function (t, r, e) {
        "use strict";
        e.r(r), e.d(r, { default: function () { return s; } });
        for (var n = [], o = 0; o < 64;)
            n[o] = 0 | 4294967296 * Math.sin(++o % Math.PI);
        function s(t) { var r, e, s, i = [r = 1732584193, e = 4023233417, ~r, ~e], u = [], a = unescape(encodeURI(t)) + "", c = a.length; for (t = --c / 4 + 2 | 15, u[--t] = 8 * c; ~c;)
            u[c >> 2] |= a.charCodeAt(c) << 8 * c--; for (o = a = 0; o < t; o += 16) {
            for (c = i; a < 64; c = [s = c[3], r + ((s = c[0] + [r & e | ~r & s, s & r | ~s & e, r ^ e ^ s, e ^ (r | ~s)][c = a >> 4] + n[a] + ~~u[o | 15 & [a, 5 * a + 1, 3 * a + 5, 7 * a][c]]) << (c = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21][4 * c + a++ % 4]) | s >>> -c), r, e])
                r = 0 | c[1], e = c[2];
            for (a = 4; a;)
                i[--a] += c[a];
        } for (t = ""; a < 32;)
            t += (i[a >> 3] >> 4 * (1 ^ a++) & 15).toString(16); return t; }
    } }, r = {}; function e(n) { var o = r[n]; if (void 0 !== o)
    return o.exports; var s = r[n] = { exports: {} }; return t[n].call(s.exports, s, s.exports, e), s.exports; } return e.d = function (t, r) { for (var n in r)
    e.o(r, n) && !e.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: r[n] }); }, e.o = function (t, r) { return Object.prototype.hasOwnProperty.call(t, r); }, e.r = function (t) { "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 }); }, e(2870); })(); }));
//# sourceMappingURL=tsub.js.map